// extracted by mini-css-extract-plugin
export default {"box":"FilterPanel_box__xeV2l","clear-button":"FilterPanel_clear-button__4BpMI","cross":"FilterPanel_cross__9yt6s"};